module.exports = __webpack_public_path__ + "static/media/person8.43b9d088.png";